import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { Box, LoadingOverlay, Text, Grid, Card, Group, ThemeIcon, Title, Tabs } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getPackageDetail } from '../../../../store/packageDetail'
import { IconShip, IconTruck } from '@tabler/icons-react'
import PackageShipmentStatus from '../../../../component/pages/Orders/Package/PackageShipmentStatus'
import PackageShipmentItems from '../../../../component/pages/Orders/Package/PackageShipmentItems'

const defaultTab = [
  {
    label: 'Tracking Status',
    value: 'tracking_status'
  },
  {
    label: 'Package Items',
    value: 'package_items'
  }
]

const defaultTabPanel = [
  {
    value: 'tracking_status',
    component: PackageShipmentStatus,
  },
  {
    value: 'package_items',
    component: PackageShipmentItems,
  },
]

const DetailPackageShipment = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const orderId = params.order_id
  const packageId = params.package_id
  const { isLoadingPackage, info_package } = useSelector(state => state.package_detail)
  const [activeTab, setActiveTab] = useState('tracking_status')


  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Order',
      route: '/order/all'
    },
    {
      label: `${orderId}`,
      route: `/order/${orderId}`
    },
    {
      label: 'Package Shipment',
      route: null
    }
  ]

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    dispatch(getPackageDetail(packageId))
    // eslint-disable-next-line
  }, [dispatch])

  const mappingTabPackage = (dataTabs) => {
    const remapTopTabs = dataTabs.map((val, index) => {
      return (<Tabs.Tab key={index} value={val.value} style={{ color: val.value === activeTab ? 'red' : 'gray', fontWeight: val.value === activeTab ? 'bold' : '400' }}>{val.label}</Tabs.Tab>)
    })
    return remapTopTabs
  }

  const mappingPanelTab = (dataPanels) => {
    const remapTopPanels = dataPanels.map((val, index) => {
      return (<Tabs.Panel key={index} value={val.value}><val.component /></Tabs.Panel>)
    })
    return remapTopPanels
  }

  return (
    <AuthLayout>
      <Box pos='relative'>
        <LoadingOverlay visible={isLoadingPackage} zIndex={1000} overlayProps={{ radius: "sm", blur: 3 }} />
        <Box my={8}>
          <Text className={classes.titleLayout}>Package Shipment</Text>
        </Box>
        <Box my={20}>
          <Grid align='start' overflow='hidden'>
            <Grid.Col span={6}>
              <Card withBorder shadow="xs" radius="md" padding='md'>
                <Card.Section withBorder inheritPadding py="xs">
                  <Title size={16} py={6.5}>Order Information</Title>
                </Card.Section>
                <Card.Section withBorder inheritPadding py='md' h={366}>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Order ID</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.order_code || '-'}</Text>
                  </Box>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Package Name</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.name || '-'}</Text>
                  </Box>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Total CBM</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.total_cbm} CBM</Text>
                  </Box>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Total Net Weight</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.total_net_weight} KG</Text>
                  </Box>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Total Gross Weight</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.total_weight} KG</Text>
                  </Box>
                </Card.Section>
              </Card>
            </Grid.Col>
            <Grid.Col span={6}>
              <Card withBorder shadow="xs" radius="md" padding='md' mb={16}>
                <Card.Section withBorder inheritPadding py="xs">
                  <Group gap='sm' align='center'>
                    <ThemeIcon variant="light" radius="xl" size="lg" color='violet.8'>
                      <IconShip style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Title size={16} c='violet.8'>First Mile</Title>
                  </Group>
                </Card.Section>
                <Card.Section withBorder inheritPadding py='md'>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>First Mile Courier</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.courier_name || '-'}</Text>
                  </Box>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>First Mile Tracking Code</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.tracking_code || '-'}</Text>
                  </Box>
                </Card.Section>
              </Card>
              <Card withBorder shadow="xs" radius="md" padding='md'>
                <Card.Section withBorder inheritPadding py="xs">
                  <Group gap='sm' align='center'>
                    <ThemeIcon variant="light" radius="xl" size="lg" color='violet.8'>
                      <IconTruck style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Title size={16} c='violet.8'>Last Mile</Title>
                  </Group>
                </Card.Section>
                <Card.Section withBorder inheritPadding py='md'>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Last Mile Courier</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.last_mile_courier || '-'}</Text>
                  </Box>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Last Mile Tracking Code</Text>
                    <Text fz={12} c='black' fw='600'>{info_package.tracking_code_courier || '-'}</Text>
                  </Box>
                </Card.Section>
              </Card>
            </Grid.Col>
          </Grid>
        </Box>
        <Box my={30}>
          <Tabs value={activeTab} keepMounted={false} onChange={setActiveTab}>
              <Tabs.List>
                {mappingTabPackage(defaultTab)}
              </Tabs.List>

              {mappingPanelTab(defaultTabPanel)}
            </Tabs>
        </Box>
      </Box>
    </AuthLayout>
    
  )
}

export default DetailPackageShipment